import React from "react";
import { DirectoryContent } from "./DirectoryContent";
import { DirectoryContextProvider } from "./DirectoryContextProvider";

export const DirectorySettings: React.FC = () => (
    <DirectoryContextProvider>
        <DirectoryContent />
    </DirectoryContextProvider>
);
